import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Auth, getAuth, onAuthStateChanged } from '@angular/fire/auth';
import { Observable } from 'rxjs';
import { Navigation } from 'src/app/enums/navigation.enum';

import { Race } from 'src/app/models/race';
import { RaceService } from 'src/app/services/race.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-races',
    templateUrl: './races.component.html',
    styleUrls: ['./races.component.scss'],
    standalone: false
})
export class RacesComponent implements OnInit, OnDestroy {
  raceDetail = '/'+Navigation.RaceDetail;
  races;
  upcomingRaces;
  recentRaces;
  public auth = getAuth()
  public currentUser: string;
  private authSubscription;
  constructor(
    private _raceService: RaceService,
    private _userService: UserService,
    ) {
      this.authSubscription = onAuthStateChanged(this.auth, (user) => {
        if (user) {
          // User is signed in, see docs for a list of available properties
          // https://firebase.google.com/docs/reference/js/auth.user
          this.currentUser = user.uid;
          // ...
        } else {
          // User is signed out
          // ...
        }
      }); 
    }

  ngOnInit(): void {
    // this.races = this._raceService.list();
    this.upcomingRaces = this._raceService.upcoming();
    this.recentRaces = this._raceService.recent();
  }
  ngOnDestroy(): void {
    if(this.authSubscription) {
      // unsubscribes
      this.authSubscription();
    }
  }
  update(race: Race) {
    this._raceService.update(race);
  }
  getUser() {
    return this._userService.currentUser?.uid
  }
}
